import Fuse from "fuse.js";
import { debounce } from "throttle-debounce";
import { derived } from "svelte/store";
import { dec, sortBy } from "@welshman/lib";
import { PROFILE } from "@welshman/util";
import { throttled } from "@welshman/store";
import { load } from "./subscribe.js";
import { wotGraph } from "./wot.js";
import { profiles } from "./profiles.js";
import { topics } from "./topics.js";
import { relays } from "./relays.js";
import { handlesByNip05 } from "./handles.js";
export const createSearch = (options, opts) => {
    const fuse = new Fuse(options, { ...opts.fuseOptions, includeScore: true });
    const map = new Map(options.map(item => [opts.getValue(item), item]));
    const search = (term) => {
        opts.onSearch?.(term);
        let results = term ? fuse.search(term) : options.map(item => ({ item }));
        if (opts.sortFn) {
            results = sortBy(opts.sortFn, results);
        }
        return results.map(result => result.item);
    };
    return {
        options,
        getValue: opts.getValue,
        getOption: (value) => map.get(value),
        searchOptions: (term) => search(term),
        searchValues: (term) => search(term).map(opts.getValue),
    };
};
export const searchProfiles = debounce(500, (search) => {
    if (search.length > 2) {
        load({ filters: [{ kinds: [PROFILE], search }] });
    }
});
export const profileSearch = derived([throttled(800, profiles), throttled(800, handlesByNip05)], ([$profiles, $handlesByNip05]) => {
    // Remove invalid nip05's from profiles
    const options = $profiles.map(p => {
        const isNip05Valid = !p.nip05 || $handlesByNip05.get(p.nip05)?.pubkey === p.event.pubkey;
        return isNip05Valid ? p : { ...p, nip05: "" };
    });
    return createSearch(options, {
        onSearch: searchProfiles,
        getValue: (profile) => profile.event.pubkey,
        sortFn: ({ score, item }) => {
            if (score && score > 0.1)
                return -score;
            const wotScore = wotGraph.get().get(item.event.pubkey) || 0;
            return score ? dec(score) * wotScore : -wotScore;
        },
        fuseOptions: {
            keys: [
                "nip05",
                { name: "name", weight: 0.8 },
                { name: "display_name", weight: 0.5 },
                { name: "about", weight: 0.3 },
            ],
            threshold: 0.3,
            shouldSort: false,
        },
    });
});
export const topicSearch = derived(topics, $topics => createSearch($topics, {
    getValue: (topic) => topic.name,
    fuseOptions: { keys: ["name"] },
}));
export const relaySearch = derived(relays, $relays => createSearch($relays, {
    getValue: (relay) => relay.url,
    fuseOptions: {
        keys: ["url", "name", { name: "description", weight: 0.3 }],
    },
}));
//# sourceMappingURL=search.js.map